import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { CopySource } from 'app/model/pipeline/copysource/copysource';
import { BlobTypeStoreReadSettingsAdapter, blobTypeStoreReadSettingsAdapts } from './blob-type-store-read-settings.adapter';
import { S3StoreReadSettings } from 'app/model/pipeline/copysource/store-read-settings/s3-store-read-settings';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { FilePathMode } from 'app/registries/consts/metadata-consts';

export const adapts = {
    ...blobTypeStoreReadSettingsAdapts,
    deleteFilesAfterCompletion: '*',
    prefix: '*'
}

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(S3StoreReadSettings),
    asynchronous: true,
    adapts
})
export class AmazonS3StoreReadSettingsAdapter extends BlobTypeStoreReadSettingsAdapter<S3StoreReadSettings, Model.StoreReadSettings> {
    protected override async _toModel(resource: Model.StoreReadSettings, copySource: CopySource): Promise<S3StoreReadSettings> {
        const s3Model = await super._toModel(resource, copySource);
        if (resource.prefix != null) {
            ValueAdapter.toModel(s3Model, S3StoreReadSettings.PREFIX, resource.prefix);
            s3Model.filePathMode = FilePathMode.PREFIX;
        }
        ValueAdapter.toModel(s3Model, S3StoreReadSettings.DELETE_FILE_AFTER_COMPLETION, resource.deleteFilesAfterCompletion);
        return s3Model;
    }

    protected override async _toResource(settings: S3StoreReadSettings): Promise<Model.StoreReadSettings> {
        const s3Resource = await super._toResource(settings);
        if (s3Resource != null) {
            if (settings.filePathMode === FilePathMode.PREFIX) {
                s3Resource.prefix = ValueAdapter.toResource(settings, S3StoreReadSettings.PREFIX);
                s3Resource.wildcardFileName = s3Resource.wildcardFolderPath = undefined;
            } else if (settings.filePathMode === FilePathMode.WILDCARD) {
                s3Resource.prefix = undefined;
            } else  {
                s3Resource.prefix = undefined;
                s3Resource.wildcardFileName = s3Resource.wildcardFolderPath = undefined;
            }
            s3Resource.deleteFilesAfterCompletion = ValueAdapter.toResource(settings, S3StoreReadSettings.DELETE_FILE_AFTER_COMPLETION);
        }
        return s3Resource;
    }
}
